module.exports = __webpack_public_path__ + "static/media/room4.1c880599.png";